//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { Transition } from "@headlessui/react";
import React, { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import { NavLink, useLocation } from "react-router-dom";
import { classNames, responsiveClassName } from "../utils/classNames";

const getStartingPath = (path) => "/" + path.split("/")[1].replace("#", "");

const Sidebar = (props: any) => {
  const { navigation, isSidebarOpen } = props;
  const location = useLocation();
  const [currentRoute, setCurrentRoute] = useState(
    getStartingPath(location.pathname)
  );

  useEffect(() => {
    if (!location.pathname.startsWith(currentRoute)) {
      setCurrentRoute(getStartingPath(location.pathname));
      window.sessionStorage.clear();
    }
    if (currentRoute.length === 1) {
      window.sessionStorage.clear();
      setCurrentRoute(getStartingPath(location.pathname));
    }
  }, [currentRoute, location]);

  return (
    <Transition
      show={true}
      className={classNames(
        isMobile
          ? tw`hidden`
          : tw`relative h-full p-1 overflow-y-auto overflow-x-hidden transition-all duration-300 ease-in-out `,
        isSidebarOpen ? tw`w-[15rem]` : tw`w-[4rem]`
      )}
    >
      <div
        className={responsiveClassName(
          "rounded-md h-full overflow-y-auto  bg-white",
          "rounded-md h-full overflow-y-auto no-scrollbar  px-2 bg-gradient-to-b from-primary-light"
        )}
      >
        <ul>
          {navigation?.map((item: any, index: number) => (
            <li key={index}>
              <span
                className={classNames(
                  isSidebarOpen ? tw`pt-2 block text-gray-500` : tw`hidden`
                )}
              >
                {item.name}
              </span>
              <span
                className={classNames(
                  isSidebarOpen ? tw`hidden` : tw`pt-2 block`
                )}
              >
                <hr
                  className={classNames(
                    tw`border-primary`,
                    index === 0 ? tw`hidden` : tw``
                  )}
                />
              </span>
              {item.children.length && (
                <>
                  <ul className={classNames(isSidebarOpen ? tw`ml-2` : tw``)}>
                    {item.children.map((subMenu: any, subIndex: number) => (
                      <React.Fragment key={`subIndex-${subIndex}`}>
                        <NavLink
                          key={subIndex}
                          to={subMenu.href}
                          className={({ isActive, isPending }) =>
                            classNames(
                              isActive
                                ? tw`bg-primary-active rounded text-primary`
                                : isPending
                                ? tw`text-indigo-100 hover:bg-indigo-600`
                                : "",
                              isSidebarOpen
                                ? ""
                                : tw`items-center justify-center`,
                              tw`text-gray-700 my-1 cursor-pointer px-2 py-[4px] flex`
                            )
                          }
                        >
                          <span
                            className={classNames(
                              isSidebarOpen ? tw`w-6` : tw`w-12`
                            )}
                            style={{
                              color:
                                location.pathname === subMenu.href
                                  ? "var(--primary)"
                                  : "gray",
                            }}
                          >
                            <subMenu.icon
                              color={
                                location.pathname === subMenu.href
                                  ? "var(--primary)"
                                  : "gray"
                              }
                              className={tw`w-full h-full`}
                            />
                          </span>
                          {isSidebarOpen && (
                            <span
                              className={classNames(
                                isSidebarOpen
                                  ? tw`ml-2 py-1 truncate max-w-[120px]`
                                  : tw`hidden`
                              )}
                              title={subMenu.name}
                            >
                              {subMenu.name}
                            </span>
                          )}
                        </NavLink>
                      </React.Fragment>
                    ))}
                  </ul>
                </>
              )}
            </li>
          ))}
        </ul>
      </div>
    </Transition>
  );
};

export default Sidebar;
